import React from 'react';
import { X, Play, Pause, Archive, Trash2, Check } from 'lucide-react';

const BulkActionsBar = ({ selectedCount, onStatusChange, onDelete, onClear }) => {
  const handleStatusChange = (status) => {
    onStatusChange?.(status);
  };

  const handleDelete = () => {
    onDelete?.();
  };

  return (
    <div className="mx-6 mb-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Check className="w-4 h-4 text-blue-600" />
              <span className="text-sm font-medium text-blue-900">
                {selectedCount} funnel{selectedCount !== 1 ? 's' : ''} selected
              </span>
            </div>
            
            <div className="h-4 border-l border-blue-300"></div>
            
            <div className="flex items-center gap-2">
              <span className="text-sm text-blue-800">Bulk Actions:</span>
              
              <button
                onClick={() => handleStatusChange('active')}
                className="inline-flex items-center gap-1 px-3 py-1 bg-green-100 text-green-800 rounded-md hover:bg-green-200 transition-colors text-sm"
              >
                <Play className="w-3 h-3" />
                Activate
              </button>
              
              <button
                onClick={() => handleStatusChange('paused')}
                className="inline-flex items-center gap-1 px-3 py-1 bg-yellow-100 text-yellow-800 rounded-md hover:bg-yellow-200 transition-colors text-sm"
              >
                <Pause className="w-3 h-3" />
                Pause
              </button>
              
              <button
                onClick={() => handleStatusChange('archived')}
                className="inline-flex items-center gap-1 px-3 py-1 bg-orange-100 text-orange-800 rounded-md hover:bg-orange-200 transition-colors text-sm"
              >
                <Archive className="w-3 h-3" />
                Archive
              </button>
              
              <button
                onClick={handleDelete}
                className="inline-flex items-center gap-1 px-3 py-1 bg-red-100 text-red-800 rounded-md hover:bg-red-200 transition-colors text-sm"
              >
                <Trash2 className="w-3 h-3" />
                Delete
              </button>
            </div>
          </div>
          
          <button
            onClick={onClear}
            className="flex items-center gap-1 text-blue-600 hover:text-blue-800 transition-colors text-sm"
          >
            <X className="w-4 h-4" />
            Clear Selection
          </button>
        </div>
        
        <div className="mt-3 pt-3 border-t border-blue-200">
          <div className="text-xs text-blue-700">
            <strong>Note:</strong> Bulk actions will apply to all selected funnels. 
            Status changes are immediate, but deletions are permanent and cannot be undone.
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;